import React from 'react'
import { Outlet } from 'react-router-dom'

export const DongleBase: React.FC = () => {
  return <Outlet />
}
